import { render } from "./NoticiasCarousel.vue?vue&type=template&id=0485f9ec"
import script from "./NoticiasCarousel.vue?vue&type=script&lang=js"
export * from "./NoticiasCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__